import { NgModule } from '@angular/core';
import { DarkenOnHouverDirective } from './darken-on-hover.directive';



@NgModule({
  declarations: [DarkenOnHouverDirective],
  exports: [DarkenOnHouverDirective]
})
export class DarkenOnHouverDirectiveModule { }
